import React from 'react';

const useInlineForm = <FormValues>(
  initialValues: FormValues,
  onSubmit: (values: FormValues) => void
) => {
  const [values, setValues] = React.useState<FormValues>(initialValues);

  const handleSubmission = (values: any) => {
    setValues(values);
    onSubmit(values);
  };

  return {
    formikProps: {
      initialValues: values,
      enableReinitialize: true,
      onSubmit: handleSubmission,
    },
  };
};

export default useInlineForm;
